<template>
    <div class="container">
        <div class="row">
            <div class="col-md-6">
                <h2>Edit</h2> 
                <h4>Email Template</h4>
            </div>
        </div> 
        <div class="row mt-4">
            <form novalidate="novalidate" @submit.prevent="submit"  class="col col-md-12 border-top border-bottom py-4"> 
                <div class="form-group row">
                    <div class="col-sm-12">
                        <editor id="tinymce" v-model="template" :init="init"></editor>
                    </div>
                </div> 
                <div class="form-group row">
                    <div class="col-sm-10">
                        <button type="submit" class="btn btn-primary" v-if="! this.loading">Edit</button>
                        <button type="submit"  class="btn btn-primary" disabled v-else>
                            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                            Loading...
                        </button>
                    </div>
                </div> 
                <router-link :to="{name:'home'}">Back</router-link>
            </form>
        </div>
    </div>
</template>

<script>
import EmailTemplateService from "../../../services/EmailTemplateService";
/* eslint-disable */
import tinymce from 'tinymce/tinymce';
/* eslint-enable */
import Editor from '@tinymce/tinymce-vue';
import 'tinymce/icons/default';
import 'tinymce/themes/silver';
import 'tinymce/skins/ui/oxide/skin.min.css'
import 'tinymce/skins/ui/oxide/content.min.css'
import 'tinymce/skins/content/default/content.min.css'
import 'tinymce/plugins/table';
import 'tinymce/plugins/image';
import 'tinymce/plugins/autoresize';

export default {
    data: function () {
        return {
            id: '',
            loading: false,
            template: '',
            errors: {},
            init: {
                height: 500,
                toolbar: 'undo redo | bold italic underline strikethrough | fontselect fontsizeselect formatselect | alignleft aligncenter alignright alignjustify | outdent indent |  numlist bullist | forecolor backcolor removeformat | insertfile image table',
                branding: false,
                menubar: false,
                plugins: 'table image autoresize',
                autoresize_min_height: 400,
                autoresize_max_height: 800,
            }
        }
    },

    components: {
        editor: Editor
    },

    mounted(){
        this.template = this.$store.state.currentUser.force.email_template.template;
        this.id = this.$store.state.currentUser.force.email_template.id;
    },

    methods: {
        submit: function () {
            EmailTemplateService.update(this.id, this.formData())
                .then( ({data}) => this.success(data) )
                .catch( ({response}) => this.failed(response) );
        },

        formData: function () {
            return {
                template: this.template
            };
        },

        success: function () {   
            window.scrollTo(0,0);         
            window.flash('Email Template Updated');
        },

        failed: function (response) {
            this.errors = response.data.errors;
        },

        hasError: function (key) {
            return (this.errors[key]);
        },
    },
}
</script>